import * as bootstrap from 'bootstrap';

const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('M99ELKPHNR', 'NWNmZWZjNmI4YTU1MmE4ZWI5OTBiYTQxMDk1ZDlmNWFjOWFmMDg5NzI5MjQwZDE1MjMyODU5MmIzNWQzOGE5OXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE');
const indexName = 'cdn_public_v1';
const widgetsForAttributes = {
  'meta.Product_Category': 'menu',
  'meta.Product_Series': 'refinementList',
  'meta.Brand_Name': 'refinementList',  
  'meta.Software_Series': 'refinementList',
  'meta.Resource_Type': 'refinementList',
/*   'meta.Information_Type': 'refinementList', */
  'meta.Base_SKU': 'refinementList',
  'docno': 'refinementList',
  'format': 'refinementList',
  'lang': 'menu',
};

// Raymarine icons
const iconpdf = new URL('url:./assets/graphics/icon-pdf.svg', import.meta.url).href;
const iconweb = new URL('url:./assets/graphics/icon-web.svg', import.meta.url).href;
const iconzip = new URL('url:./assets/graphics/icon-zip.svg', import.meta.url).href;
const iconprint = new URL('url:./assets/graphics/icon-print.svg', import.meta.url).href;

const iconMap = {
  pdf: iconpdf,
  web: iconweb,
  zip: iconzip,
  print: iconprint
};

let url = window.location.href.split('?')[0];
let params = new URLSearchParams(window.location.search);
if (!params.has('lang')) params.set('lang', 'en-US');
window.history.replaceState(history.state, "", url + "?" + params.toString());

const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const state = uiState[indexName];
        const route = {
          query: state.query,
          page: state.page
        };
        ['refinementList', 'hierarchicalMenu', 'menuSelect', 'menu'].forEach((widget) => {
          if (state[widget]) {
            for (var attribute in state[widget]) {
              route[attribute] = state[widget][attribute];
            }
          }
        });
        return route;
      },
      routeToState(routeState) {
        const state = {
          [indexName]: {
            refinementList: {},
            hierarchicalMenu: {},
            menuSelect: {},
            menu: {},
          },
        };
        for (const key in routeState) {
          if (key in widgetsForAttributes) {
            const widget = widgetsForAttributes[key];
            state[indexName][widget][key] = routeState[key];
            continue;
          }
          ['query', 'page'].forEach((attribute) => {
            if (key === attribute) {
              state[indexName][attribute] = routeState[key];
            }
          });
        }
        return state;
      },
    },
  },
});

function get(fallback, obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) return fallback;
  if (rest.length === 0 && obj.hasOwnProperty(level)) {
      if ((obj[level] === null) && (fallback !== null)) return fallback;
      return obj[level];
  }
  return get(fallback, obj[level], ...rest);
}

function set(obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) throw Error("Invalid object supplied!");
  if ((level === undefined) || (level === null)) throw Error("At least one level must be supplied");
  if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
  if (rest.length === 1) {
    obj[level] = rest[0];
  } else {
    set(obj[level], ...rest);
  }
}

function transformItems(attributes, items) {
  if (attributes) {
    if (!Array.isArray(attributes)) attributes = [attributes];
    // a specific attribute (facet)
    return items.map((item) => {
      for (const attribute of attributes) {
        if ((attribute in transformations) && (item.label in transformations[attribute])) {
          return {
            ...item,
            label: transformations[attribute][item.label],
            highlighted: transformations[attribute][item.label],
          };
        }
      }
      return item;
    });
  } else {
    // search results
    return items.map((item) => {
      let result = Object.assign({}, item);
      for (let attribute in item) {
        if ((attribute in transformations) && (item[attribute] in transformations[attribute])) {
          result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
          };
        } else {
          Object.keys(transformations).forEach((attribute) => {
            let fields = attribute.split('.');
            if (fields.length > 0) {
              let value = get(null, item, ...fields);
              if ((value != null) && (value in transformations[attribute])) {
                set(result, ...fields, transformations[attribute][value]);
              }
            }
          })
        }
      }
      return result;
    });
  }
}

function getCardTemplate(hit) {
  return `
  <article class="card">
    ${getCardBody(hit)}
    ${getCardFooter(hit)}
    </article>`

}

function getCardBody(hit) {

  // Typical situation, a document title is its product names can be more than one
  const productseries = Array.isArray(hit.meta.Product_Series)
  ? hit.meta.Product_Series.join(', ')
  : String(hit.meta.Product_Series).replace(/,/g, ', ');
  
  // Or, somtimes Raymarine uses booktitlealt to produce a custom title. In some documents the ele
  const title = (hit.meta.booktitlealt && hit.meta.booktitlealt.length && hit.meta.booktitlealt[0] !== '')
  ? hit.meta.booktitlealt
  : productseries;

  const iconSrc = iconMap[hit.format] || iconweb;

  //Note that it is possible to insert info in card as hover with attribute title="SKU: ${hit.meta.Base_SKU}"

  return  `
    <div class="card-body">
      <div class="row">
        <div class="col-8 pe-2">
          <a class="link-primary text-decoration-none" target="_blank" href="${hit.url }">
            <h4 class="card-title">${title}</h4>
          </a>
          <h4 class="card-subtitle" mb-2>${hit.meta.Resource_Type}</h4>
          
        </div>
        <div class="col-4 ps-0 d-flex justify-content-end align-items-start">
          <a href="${hit.url }"><img src="${iconSrc}" alt="Resource icon" class="icon-format"/></a>
        </div>
      </div>
      <div class="row">
        <h6 class="card-text mb-2">${hit.meta.Resource_Type_Desc }</h6>
      </div>
    </div>`
}

function getCardFooter(hit) {
return  `
<div class="card-footer"> 
  <div class="row">
    <h4 class="card-text">${hit.lang}</h4>
  </div>
</div>`  
}

/* function getCardFooter(hit) {
return  `
<div class="card-footer">
 <div class="row">
    <div class="col">
      <language-picker
        size="sm"
        lazy="true"
        class="navbar-language-picker"
        variant="lp"
        menuVariant="lp"
        docno="${hit.docno}"
        default="${hit.lang}"
        version="${hit.version}"
        urlprefix=""
        algoliaAppId="M99ELKPHNR"
        algoliaApiKey="NWNmZWZjNmI4YTU1MmE4ZWI5OTBiYTQxMDk1ZDlmNWFjOWFmMDg5NzI5MjQwZDE1MjMyODU5MmIzNWQzOGE5OXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE"
        algoliaIndexName="cdn_public_v1">
      </language-picker>
    </div>
  </div>
</div>`  
} */


search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Search by Product Name, SKU, Product Category, or Resource Type',
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    transformItems: transformItems.bind(this, null),
    templates: {
      item: (hit) => {
       return getCardTemplate(hit); 
      }
    },
  }),
  instantsearch.widgets.menu({
    container: '#Product_Category-menu',
    transformItems: transformItems.bind(this, 'meta.Product_Category'),
    attribute: 'meta.Product_Category',
    cssClasses: {
      link: 'link-primary',
    },
    limit: 4,
    showMore: true,
    showMoreLimit: 100
  }),
  instantsearch.widgets.refinementList({
    container: '#Product_Series-list',
    transformItems: transformItems.bind(this, 'meta.Product_Series'),
    attribute: 'meta.Product_Series',
    limit: 4,
    showMore: true,
    showMoreLimit: 200
  }),
    instantsearch.widgets.refinementList({
    container: '#Brand_Name-list',
    transformItems: transformItems.bind(this, 'meta.Brand_Name'),
    attribute: 'meta.Brand_Name',
    limit: 4,
    showMore: true
  }),
  instantsearch.widgets.refinementList({
    container: '#Software_Series-list',
    transformItems: transformItems.bind(this, 'meta.Software_Series'),
    attribute: 'meta.Software_Series',
    limit: 6,
    showMore: true
  }),
  instantsearch.widgets.refinementList({
    container: '#Resource_Type-list',
    transformItems: transformItems.bind(this, 'meta.Resource_Type'),
    attribute: 'meta.Resource_Type',
    limit: 4,
    showMore: true
  }),
/*   instantsearch.widgets.refinementList({
    container: '#Information_Type-list',
    transformItems: transformItems.bind(this, 'meta.Information_Type'),
    attribute: 'meta.Information_Type',
  }), 
  instantsearch.widgets.refinementList({
    container: '#Base_SKU-list',
    transformItems: transformItems.bind(this, 'meta.Base_SKU'),
    attribute: 'meta.Base_SKU',
    limit: 15,
    showMore: true
  }),*/
  instantsearch.widgets.refinementList({
    container: '#docno-menu',
    transformItems: transformItems.bind(this, 'docno'),
    attribute: 'docno',
    cssClasses: {
      link: 'link-primary',
    },
  }),
  instantsearch.widgets.refinementList({
    container: '#format-list',
    transformItems: transformItems.bind(this, 'format'),
    attribute: 'format',
  }),
  instantsearch.widgets.menuSelect({
    container: '#lang-select',
    transformItems: transformItems.bind(this, 'lang'),
    attribute: 'lang',
    templates: {
      defaultOption: 'Any',
    }
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
  instantsearch.widgets.configure({
    maxValuesPerFacet: 100
  }),
]);

search.start();
